import { AlertCircle } from "lucide-react";
import { useEffect } from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";

function getErrorMessage(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return "This page could not be found.";
    }
    return error.data && typeof error.data === "string"
      ? error.data
      : `${error.status} ${error.statusText || "Error"}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "An unexpected error occurred";
}

export function GlobalRouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = getErrorMessage(error);

  useEffect(() => {
    console.error("Route error:", message);
  }, [message]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="text-center space-y-4 max-w-md">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-4">
            <AlertCircle className="h-8 w-8 text-destructive" />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
        <p className="text-muted-foreground">{message}</p>
        <div className="flex flex-wrap items-center justify-center gap-2 pt-2">
          <Button type="button" onClick={() => window.location.reload()}>
            Reload page
          </Button>
          <Button type="button" variant="outline" onClick={() => navigate("/", { replace: true })}>
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
